export default {
  serverURL: 'https://demo-server.aabvie.net', //'http://localhost:13000'
}
